import React from 'react'
import SavingImg1 from '../../Images/SavingImg/AbadhikSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const AabadhikSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>आवधिक बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>उच्चतम ब्याज प्राप्त गर्ने सकिने ।</li>
                                        <li>तोकिएको समयपछि रकम फिर्ता गरी खाता बन्द गर्न सकिने वा पुनः राख्न सकिने ।</li>
                                        <li>आवधिक बचतको आधारमा प्राप्त ब्याजमा थप २% दरमा ऋण प्राप्त गर्न सकिने । </li>
                                        <li>सम्झौतामा तोकिएको समयावधिभन्दा अगावै बचत फिर्ता नहुने । </li>
                                        <li>ब्याजलाई संरक्षित पूँजी फिर्ता कोष वितरणमा गणना गरिने ।</li>
                                        <li>न्युनतम मौज्दात रु १,०००।– राखि खाता खोल्न सकिनेछ ।</li>
                                    </ul>

                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default AabadhikSaving